"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Settings/AccountRoleToggles.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _useOrgAccount = require('shared/hooks/useOrgAccount');
var _Form = require('web/components/Form');










/* The IT and Owner choice (D-38), at most one on, with the D-38 warning
 * under the newly chosen role. */
const AccountRoleToggles = ({ roles, value, onChange, current = null, isRoleDisabled }) => (
  _react2.default.createElement(_react2.default.Fragment, null
    ,  roles.map(r => (
      _react2.default.createElement(_Form.Toggle, {
        key: r,
        label: _useOrgAccount.ACCOUNT_ROLE_LABELS[r],
        hint: _useOrgAccount.ACCOUNT_ROLE_HINTS[r],
        warning: value === r && r !== current ? _useOrgAccount.ACCOUNT_ROLE_WARNING : undefined,
        isChecked: value === r,
        isDisabled: _optionalChain([isRoleDisabled, 'optionalCall', _ => _(r)]),
        onChange: isOn => onChange(isOn ? r : null), __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}
      )
    ))
  )
)

exports. default = AccountRoleToggles
